import { render, staticRenderFns } from "./cadcofrescontas.vue?vue&type=template&id=cec89bf4"
import script from "./cadcofrescontas.vue?vue&type=script&lang=js"
export * from "./cadcofrescontas.vue?vue&type=script&lang=js"
import style0 from "./cadcofrescontas.vue?vue&type=style&index=0&id=cec89bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports